module.exports = __webpack_public_path__ + "static/media/f7.251edcbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/Documentation/images/f7.jpg
// module id = 400
// module chunks = 0